module.exports = __webpack_public_path__ + "static/media/cover10.12c6f5d7.jpeg";